// import * as io from 'socket.io-client';
// // import io from 'socket.io-client';

// // "undefined" means the URL will be computed from the `window.location` object
// const URL = process.env.REACT_APP_SOCKET_URL ;

// export const socket = io(URL);